// removed by extract-text-webpack-plugin
module.exports = {"templateHeroOffset":"CategoryHeader__templateHeroOffset___AquLB","descriptionBottom":"CategoryHeader__descriptionBottom___2xB8e","templateHero":"CategoryHeader__templateHero___1V5Va","categoryName":"CategoryHeader__categoryName___2ja2O"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/css/CategoryHeader.less
// module id = 75
// module chunks = 0 1